// extracted by mini-css-extract-plugin
export default {"text":"withError_text__Jwq+8","withError":"withError_withError__p6dOu","error":"withError_error__yAM1g","info":"withError_info__UL8+y"};